export default __webpack_public_path__ + "static/media/tick-green.fc282ed8.svg";